import React from 'react';
import './Privacy.css';

const Privacy: React.FC = () => {
  return (
    <div className="privacy-page">
      <div className="container">
        <div className="privacy-content">
          <h1>Slot In App Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
          
          <div className="privacy-section">
            <h2>Data Collection</h2>
            <p>
              Slot In App does not collect, store, or use any personal data from users. 
              Our scheduling application is designed to operate without requiring any personal information.
            </p>
          </div>
          
          <div className="privacy-section">
            <h2>Data Usage</h2>
            <p>
              Since Slot In App does not collect any data, there is no data usage to disclose. 
              Your privacy is protected by design when using our scheduling solution.
            </p>
          </div>
          
          <div className="privacy-section">
            <h2>Data Sharing</h2>
            <p>
              Slot In App does not share any data with third parties because we do not collect any data 
              in the first place.
            </p>
          </div>
          
          <div className="privacy-section">
            <h2>Contact Information</h2>
            <p>
              If you have any questions about this privacy policy or need support with Slot In App, 
              please contact us at: <a href="mailto:support@gerund.dev">support@gerund.dev</a>
            </p>
          </div>
          
          <div className="privacy-section">
            <h2>Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. Any changes will be posted 
              on this page with an updated revision date.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy; 